// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3CH5D","choiceBoxes":"toolbarselects_choiceBoxes__1AUis","simpleField":"toolbarselects_simpleField__23ZHV"};